function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
import styled from "styled-components";
import { Label } from "../";
export const Pill = ({
  color = "teal",
  label,
  ...props
}) => {
  const legacyCheck = // check for legacy keys
  color === "action" ? "purple" : color === "approved" ? "green" : color === "pending" ? "orange" : color;
  return /*#__PURE__*/React.createElement(PillContainer, _extends({
    color: legacyCheck
  }, props), /*#__PURE__*/React.createElement(PillLabel, {
    color: legacyCheck
  }, label));
};
const PillContainer = styled.div`
  border-radius: 24px;
  box-sizing: border-box;
  display: inline-block;
  padding: 3px 8px;
  background-color: ${({
  color,
  theme
}) => color ? theme.palette[color].lightest : "#222222"};
  & + & {
    margin-left: 8px;
  }
`;
const PillLabel = styled(Label)`
  color: ${({
  color,
  theme
}) => color ? theme.palette[color].primary : "#FFFFFF"};
  font-size: 14px;
  font-weight: 600;
  line-height: 18px;
`;